<vs-generic-modal
  [showCloseButton]="true"
  [config]="{ title: 'Renew Coverage', subtitle: 'Review your renewal before paying', size: 'md' }"
>
  <div class="p-5 min-w-[320px] max-w-lg">
    <ng-container *ngIf="success; else reviewOrLoading">
      <div class="text-center py-2">
        <vs-icon size="32" name="check-circle" class="text-success-600"></vs-icon>
      </div>
      <div class="text-center font-semibold text-base mb-4">Your coverage has been renewed</div>

      <div class="text-sm text-gray-600 mb-2">Contract #{{ success.contractNumber }}</div>
      <div class="text-sm mb-4">New expiry date: {{ success.expiryDate | date }}</div>

      <div class="font-semibold text-sm mb-2">Coverages</div>
      <div *ngFor="let coverage of success.coverages" class="flex items-center justify-between py-1 text-sm">
        <span>{{ coverageTitle(coverage.coverageId) }}</span>
        <span>{{ coverage.price / 100 | currency }}</span>
      </div>

      <div class="flex items-center justify-between font-semibold text-sm mt-3 border-t pt-3">
        <span>Total paid</span>
        <span>{{ success.totalAmountPaid / 100 | currency }}</span>
      </div>

      <div class="flex justify-end mt-5">
        <button vs-button theme="primary" (click)="close()">Done</button>
      </div>
    </ng-container>

    <ng-template #reviewOrLoading>
      <div *ngIf="loading" class="text-center py-8 text-sm text-gray-500">Loading renewal details…</div>

      <div *ngIf="error && !loading" class="text-red-600 text-sm mb-4">{{ error }}</div>

      <ng-container *ngIf="preview && !loading">
        <div class="text-sm text-gray-600 mb-2">Contract #{{ preview.contractNumber }}</div>
        <div class="text-sm mb-1">Current expiry: {{ preview.currentExpiryDate | date }}</div>
        <div class="text-sm mb-4">New expiry after renewal: {{ preview.newExpiryDate | date }}</div>

        <div *ngIf="preview.unavailableCoverageIds.length" class="text-xs text-amber-600 mb-3">
          Some of your current coverages are no longer offered and cannot be carried forward.
        </div>

        <div class="font-semibold text-sm mb-2">Coverages</div>
        <div *ngFor="let option of preview.coverageOptions" class="py-1 text-sm">
          <div class="flex items-center justify-between">
            <label class="flex items-center gap-2">
              <input
                type="checkbox"
                [checked]="selectedCoverageIds.has(option.coverageId)"
                [disabled]="!option.isRemovable"
                (change)="toggleCoverage(option.coverageId, option.isRemovable)"
              />
              {{ option.title }}
              <span *ngIf="option.isNew" class="text-xs text-primary-600">(new)</span>
            </label>
            <span>{{ option.price / 100 | currency }}</span>
          </div>
          <div
            *ngIf="option.isCarriedForward && option.isRemovable && !selectedCoverageIds.has(option.coverageId)"
            class="text-xs text-gray-500 ml-6"
          >
            You already paid for this — it stays active until {{ preview.currentExpiryDate | date }}.
          </div>
        </div>

        <div class="flex items-center justify-between font-semibold text-sm mt-3 border-t pt-3">
          <span>Total due today</span>
          <span>{{ totalAmountDue / 100 | currency }}</span>
        </div>

        <div class="mt-4">
          <div class="text-sm font-semibold mb-2">Payment method</div>
          <vs-select-or-create-payment-method
            [userId]="userId"
            [address]="address"
            [userDetails]="userDetails"
            [formControl]="paymentMethodControl"
          >
          </vs-select-or-create-payment-method>
        </div>

        <div class="flex justify-end gap-2 mt-5">
          <button vs-button appearance="clear" (click)="close()">Cancel</button>
          <button
            vs-button
            theme="primary"
            [disabled]="submitting || !paymentMethodControl.value || totalAmountDue <= 0"
            (click)="confirm()"
          >
            {{ submitting ? 'Processing…' : 'Pay & Renew' }}
          </button>
        </div>
      </ng-container>
    </ng-template>
  </div>
</vs-generic-modal>
